// src/shared/constants/color.ts
// RDC Board 2025 Figma Color Palette
// Add or update colors as needed from the Figma design system

import { tr } from "date-fns/locale";

const colors = {
  // Primary
  primary: "#1976d2", // Figma: Primary Blue
  primaryDark: "#1565c0",
  primaryLight: "#2196f3",

  // Secondary
  secondary: "#374E7D",
  secondaryLight: "#F6F8FB",

  // Success
  success: "#006644",
  successBg: "#E3FCEF",

  // Error
  error: "#BF2600",
  errorBg: "#FFEBE6",

  // Info
  info: "#253858",

  // Gray/Neutral
  gray100: "#F1F5F9",
  gray200: "#E2E8F0",
  gray300: "#CBD5E1",
  gray400: "#94A3B8",
  gray500: "#6B7280",
  gray600: "#374151",
  gray700: "#1F2937",
  gray800: "#6c757d",
  gray900: "#343a40",
  gray1000: "#64748B",
  gray1100: "#757575",
  gray1200: "#424242",
  gray1300: "#616161",

  // White/Black
  white: "#FFFFFF",
  black: "#000000",

  transparent: "transparent",

  // Other Colors
  deepBlue: "#374E7D",
  aiLinearGradient: "linear-gradient(90deg, #1968B0 5.62%, #56DB53 95.62%)",
  aiGradientStart: "#1968B0",
  aiGradientEnd: "#56DB53",
  talentspotLinearGradient: "linear-gradient(180deg, #AF34F8 0%, #FFB727 100%)",
  talentspotGradientStart: "#AF34F8",
  talentspotGradientEnd: "#FFB727",

  red: {
    R500: "#BF2600",
    R400: "#DE350B",
    R300: "#FF5630",
    R200: "#FF7452",
    R100: "#FF8F73",
    R75: "#FFBDAD",
    R50: "#FFEBE6",
  },

  yellow: {
    Y500: "#FF8B00",
    Y400: "#FF991F",
    Y300: "#FFAB00",
    Y200: "#FFC400",
    Y100: "#FFE380",
    Y75: "#FFF0B3",
    Y50: "#FFFAE6",
  },

  green: {
    G500: "#006644",
    G400: "#00875A",
    G300: "#36B37E",
    G200: "#57D9A3",
    G100: "#79F2C0",
    G75: "#ABF5D1",
    G50: "#E3FCEF",
  },

  teal: {
    T500: "#008DA6",
    T400: "#00A3BF",
    T300: "#00B8D9",
    T200: "#00C7E6",
    T100: "#79E2F2",
    T75: "#B3F5FF",
    T50: "#E6FCFF",
  },

  blue: {
    B1100: "#2c3e63",
    B1000: "#E1E9FF",
    B900: "#111827",
    B800: "#233876",
    B700: "#1976d2",
    B600: "#3D9CD6",
    B500: "#0747A6",
    B400: "#0052CC",
    B300: "#0065FF",
    B200: "#2684FF",
    B100: "#4C9AFF",
    B75: "#B3D4FF",
    B60: "#E0ECFF",
    B50: "#DEEBFF",
  },

  purple: {
    P500: "#403294",
    P400: "#5243AA",
    P300: "#6554C0",
    P200: "#8777D9",
    P100: "#998DD9",
    P75: "#C0B6F2",
    P50: "#EAE6FF",
  },

  neutral: {
    N1500: "#F3F4F6",
    N1400: "#F9FAFB",
    N1300: "#F0F4FF",
    N1200: "#E5E7EB",
    N1100: "#e9ecef",
    N1000: "#374E7D0D",
    N900: "#091E42",
    N800: "#172B4D",
    N700: "#253858",
    N600: "#344563",
    N500: "#42526E",
    N400: "#505F79",
    N300: "#5E6C84",
    N200: "#6B778C",
    N100: "#7A869A",
    N90: "#8993A4",
    N80: "#97A0AF",
    N70: "#A5ADBA",
    N60: "#B3BAC5",
    N50: "#C1C7D0",
    N40: "#DFE1E6",
    N30: "#EBECF0",
    N20: "#F4F5F7",
    N10: "#FAFBFC",
    N0: "#FFFFFF",
  },
};

export default colors;
